import React from 'react'
import Searchbar from '../Searchbar/Searchbar'
import close from '../../../img_4/close.png'
import t_search from '../../../img_4/search_t.png'
import home_t_nav from '../../../img_4/class.png'
import icon_share from '../../../img_4/share.png'
import hostName from '../../../method/hostname'
import './Header.css'

export default function Header({ cataname, top_list, setsear, searflag, setSearch, flag, setshare }) {
  const caseTransform = () => {
    let nStr = '' + cataname[0].toUpperCase()
    return nStr + cataname.substr(1)
  }

  return (
    <div className="t_head4">
      <img src={flag ? close : home_t_nav} alt="" onClick={top_list} className="t_nav" />
      <img src="" alt="" />
      <div className="icons">
        <img src={t_search} alt="" onClick={setsear} className="t_search" />
        <img src={icon_share} alt="" onClick={setshare} className="shareIcon" />
      </div>
      <h1> {window.location.pathname === '/' ? hostName : caseTransform()}</h1>
      <Searchbar searflag={searflag} setsear={setsear} setSearch={setSearch}></Searchbar>
    </div>
  )
}
